var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShipWheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.918,
    x2: 267.273,
    xlinkHref: "#lg1",
    y1: 255,
    y2: 255
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 172,
    y2: 151.823
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 333.333,
    y2: 313.156
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.958,
    x2: 273.484,
    xlinkHref: "#lg1",
    y1: 20.89,
    y2: 55.417
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.546,
    x2: 256.809,
    xlinkHref: "#lg1",
    y1: 65.033,
    y2: 85.872
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 -1 -1618 882.932)",
    gradientUnits: "userSpaceOnUse",
    x1: -1889.042,
    x2: -1854.516,
    xlinkHref: "#lg1",
    y1: 393.823,
    y2: 428.349
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 -1 -1618 882.932)",
    gradientUnits: "userSpaceOnUse",
    x1: -1875.454,
    x2: -1871.191,
    xlinkHref: "#lg1",
    y1: 437.965,
    y2: 458.805
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(0 -1 1 0 -1064 -554)",
    gradientUnits: "userSpaceOnUse",
    x1: -823.082,
    x2: -796.727,
    xlinkHref: "#lg1",
    y1: 1319,
    y2: 1319
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(0 -1 1 0 -1064 -554)",
    gradientUnits: "userSpaceOnUse",
    x1: -809,
    x2: -809,
    xlinkHref: "#lg2",
    y1: 1236,
    y2: 1215.823
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(0 -1 1 0 -1064 -554)",
    gradientUnits: "userSpaceOnUse",
    x1: -809,
    x2: -809,
    xlinkHref: "#lg2",
    y1: 1397.333,
    y2: 1377.156
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(0 -1 1 0 -1064 -554)",
    gradientUnits: "userSpaceOnUse",
    x1: -825.042,
    x2: -790.516,
    xlinkHref: "#lg1",
    y1: 1084.89,
    y2: 1119.417
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(0 -1 1 0 -1064 -554)",
    gradientUnits: "userSpaceOnUse",
    x1: -811.454,
    x2: -807.191,
    xlinkHref: "#lg1",
    y1: 1129.033,
    y2: 1149.872
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(0 1 -1 0 -181.068 1064)",
    gradientUnits: "userSpaceOnUse",
    x1: -825.042,
    x2: -790.516,
    xlinkHref: "#lg1",
    y1: -670.178,
    y2: -635.651
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(0 1 -1 0 -181.068 1064)",
    gradientUnits: "userSpaceOnUse",
    x1: -811.454,
    x2: -807.191,
    xlinkHref: "#lg1",
    y1: -626.035,
    y2: -605.196
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -56.638 646.737)",
    gradientUnits: "userSpaceOnUse",
    x1: -70.72,
    x2: -44.365,
    xlinkHref: "#lg1",
    y1: -497.362,
    y2: -497.362
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -56.638 646.737)",
    gradientUnits: "userSpaceOnUse",
    x1: -56.638,
    x2: -56.638,
    xlinkHref: "#lg2",
    y1: -580.362,
    y2: -600.539
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -56.638 646.737)",
    gradientUnits: "userSpaceOnUse",
    x1: -56.638,
    x2: -56.638,
    xlinkHref: "#lg2",
    y1: -419.028,
    y2: -439.205
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -56.638 646.737)",
    gradientUnits: "userSpaceOnUse",
    x1: -72.68,
    x2: -38.154,
    xlinkHref: "#lg1",
    y1: -731.471,
    y2: -696.945
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -56.638 646.737)",
    gradientUnits: "userSpaceOnUse",
    x1: -59.092,
    x2: -54.829,
    xlinkHref: "#lg1",
    y1: -687.329,
    y2: -666.489
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1825.065 126.966)",
    gradientUnits: "userSpaceOnUse",
    x1: -1577.404,
    x2: -1542.877,
    xlinkHref: "#lg1",
    y1: 1146.184,
    y2: 1180.71
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1825.065 126.966)",
    gradientUnits: "userSpaceOnUse",
    x1: -1563.815,
    x2: -1559.553,
    xlinkHref: "#lg1",
    y1: 1190.327,
    y2: 1211.166
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -417.263 -497.362)",
    gradientUnits: "userSpaceOnUse",
    x1: -70.72,
    x2: -44.365,
    xlinkHref: "#lg1",
    y1: 1007.362,
    y2: 1007.362
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -417.263 -497.362)",
    gradientUnits: "userSpaceOnUse",
    x1: -56.638,
    x2: -56.638,
    xlinkHref: "#lg2",
    y1: 924.362,
    y2: 904.185
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -417.263 -497.362)",
    gradientUnits: "userSpaceOnUse",
    x1: -56.638,
    x2: -56.638,
    xlinkHref: "#lg2",
    y1: 1085.695,
    y2: 1065.518
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -417.263 -497.362)",
    gradientUnits: "userSpaceOnUse",
    x1: -72.68,
    x2: -38.154,
    xlinkHref: "#lg1",
    y1: 773.252,
    y2: 807.778
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -417.263 -497.362)",
    gradientUnits: "userSpaceOnUse",
    x1: -59.092,
    x2: -54.829,
    xlinkHref: "#lg1",
    y1: 817.395,
    y2: 838.234
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -937.034 1271.065)",
    gradientUnits: "userSpaceOnUse",
    x1: -1577.404,
    x2: -1542.877,
    xlinkHref: "#lg1",
    y1: -358.539,
    y2: -324.013
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -937.034 1271.065)",
    gradientUnits: "userSpaceOnUse",
    x1: -1563.815,
    x2: -1559.553,
    xlinkHref: "#lg1",
    y1: -314.397,
    y2: -293.557
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a96c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.587,
    x2: 364.209,
    xlinkHref: "#lg3",
    y1: 148.587,
    y2: 364.209
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 -1 -1601 515)",
    gradientUnits: "userSpaceOnUse",
    x1: -1946.671,
    x2: -1762.947,
    xlinkHref: "#lg3",
    y1: 169.329,
    y2: 353.053
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 315.934,
    y2: 412.489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.5,
    x2: 291.06,
    xlinkHref: "#lg3",
    y1: 218.5,
    y2: 291.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240 77.028h30v355.943h-30z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 143.333h30v29.333h-30z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 304.667h30v29.333h-30z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m288.35 33.35c0-18.44-14.966-33.385-33.414-33.35-18.402.035-33.392 15.146-33.285 33.548.062 10.609 5.077 20.044 12.85 26.109 2.028 1.582 3.215 4.008 3.215 6.58 0 5.543 4.494 10.037 10.037 10.037h14.494c5.543 0 10.037-4.494 10.037-10.037v-.001c0-2.57 1.184-4.996 3.211-6.576 7.823-6.102 12.855-15.619 12.855-26.31z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.419 86.264h-38.837c-5.101 0-9.236-4.135-9.236-9.236 0-5.101 4.135-9.236 9.236-9.236h38.837c5.101 0 9.236 4.135 9.236 9.236-.001 5.101-4.136 9.236-9.236 9.236z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.65 476.65c0 18.44 14.966 33.385 33.414 33.35 18.402-.035 33.392-15.146 33.285-33.548-.062-10.609-5.077-20.044-12.85-26.109-2.028-1.582-3.215-4.008-3.215-6.58 0-5.543-4.494-10.037-10.037-10.037h-14.494c-5.543 0-10.037 4.494-10.037 10.037v.001c0 2.57-1.184 4.996-3.211 6.576-7.823 6.102-12.855 15.619-12.855 26.31z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.581 423.736h38.837c5.101 0 9.236 4.135 9.236 9.236 0 5.101-4.135 9.236-9.236 9.236h-38.837c-5.101 0-9.236-4.135-9.236-9.236.001-5.101 4.136-9.236 9.236-9.236z",
    fill: "url(#SVGID_7_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m432.972 240v30h-355.944v-30z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.333 240h29.333v30h-29.333z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.667 240h29.333v30h-29.333z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.35 221.65c-18.44 0-33.385 14.966-33.35 33.414.035 18.402 15.146 33.392 33.548 33.285 10.609-.062 20.044-5.077 26.109-12.85 1.582-2.028 4.008-3.215 6.58-3.215 5.543 0 10.037-4.494 10.037-10.037v-14.494c0-5.543-4.494-10.037-10.037-10.037h-.001c-2.57 0-4.996-1.184-6.576-3.211-6.102-7.823-15.619-12.855-26.31-12.855z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.264 235.581v38.837c0 5.101-4.135 9.236-9.236 9.236-5.101 0-9.236-4.135-9.236-9.236v-38.837c0-5.101 4.135-9.236 9.236-9.236 5.101.001 9.236 4.136 9.236 9.236z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.65 288.35c18.44 0 33.385-14.966 33.35-33.414-.035-18.402-15.146-33.392-33.548-33.285-10.609.062-20.044 5.077-26.109 12.85-1.582 2.028-4.008 3.215-6.58 3.215-5.543 0-10.037 4.494-10.037 10.037v14.494c0 5.543 4.494 10.037 10.037 10.037h.001c2.57 0 4.996 1.184 6.576 3.211 6.102 7.823 15.619 12.855 26.31 12.855z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.736 274.419v-38.837c0-5.101 4.135-9.236 9.236-9.236 5.101 0 9.236 4.135 9.236 9.236v38.837c0 5.101-4.135 9.236-9.236 9.236-5.101-.001-9.236-4.136-9.236-9.236z",
    fill: "url(#SVGID_14_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m139.762 391.452-21.214-21.214 251.69-251.69 21.214 21.214z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.612 186.175 21.213 21.213 20.742-20.742-21.213-21.213z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.532 300.255 21.213 21.213 20.742-20.742-21.213-21.213z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.312 121.851c13.039-13.039 13.024-34.189-.046-47.209-13.037-12.988-34.321-12.902-47.258.186-7.458 7.545-10.583 17.763-9.376 27.549.315 2.553-.561 5.108-2.379 6.926-3.92 3.92-3.92 10.274 0 14.194l10.249 10.249c3.92 3.92 10.274 3.92 14.194 0 1.817-1.817 4.37-2.695 6.92-2.38 9.849 1.217 20.136-1.954 27.696-9.515z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.045 149.417-27.462-27.462c-3.607-3.607-3.607-9.454 0-13.061 3.607-3.607 9.454-3.607 13.061 0l27.462 27.462c3.607 3.607 3.607 9.454 0 13.061-3.606 3.606-9.454 3.606-13.061 0z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.688 388.149c-13.039 13.039-13.024 34.189.046 47.209 13.037 12.988 34.321 12.902 47.258-.186 7.458-7.545 10.583-17.763 9.376-27.549-.315-2.553.561-5.108 2.379-6.926 3.92-3.92 3.92-10.274 0-14.194l-10.249-10.249c-3.92-3.92-10.274-3.92-14.194 0-1.817 1.817-4.37 2.695-6.92 2.38-9.849-1.217-20.136 1.954-27.696 9.515z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.955 360.583 27.462 27.462c3.607 3.607 3.607 9.454 0 13.061-3.607 3.607-9.454 3.607-13.061 0l-27.462-27.462c-3.607-3.607-3.607-9.454 0-13.061 3.606-3.606 9.454-3.606 13.061 0z",
    fill: "url(#SVGID_21_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m391.452 370.238-21.214 21.214-251.69-251.69 21.214-21.214z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.175 207.388 21.213-21.213-20.742-20.742-21.213 21.213z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.255 321.468 21.213-21.213-20.742-20.742-21.213 21.213z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m121.851 74.688c-13.039-13.039-34.189-13.024-47.209.046-12.988 13.037-12.902 34.321.186 47.258 7.545 7.458 17.763 10.583 27.549 9.376 2.553-.315 5.108.561 6.926 2.379 3.92 3.92 10.274 3.92 14.194 0l10.249-10.249c3.92-3.92 3.92-10.274 0-14.194-1.817-1.817-2.695-4.37-2.38-6.92 1.217-9.849-1.954-20.136-9.515-27.696z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.417 121.955-27.462 27.462c-3.607 3.607-9.454 3.607-13.061 0-3.607-3.607-3.607-9.454 0-13.061l27.462-27.462c3.607-3.607 9.454-3.607 13.061 0 3.606 3.606 3.606 9.454 0 13.061z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m388.149 435.312c13.039 13.039 34.189 13.024 47.209-.046 12.988-13.037 12.902-34.321-.186-47.258-7.545-7.458-17.763-10.583-27.549-9.376-2.553.315-5.108-.561-6.926-2.379-3.92-3.92-10.274-3.92-14.194 0l-10.249 10.249c-3.92 3.92-3.92 10.274 0 14.194 1.817 1.817 2.695 4.37 2.38 6.92-1.217 9.849 1.954 20.136 9.515 27.696z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.583 388.045 27.462-27.462c3.607-3.607 9.454-3.607 13.061 0 3.607 3.607 3.607 9.454 0 13.061l-27.462 27.462c-3.607 3.607-9.454 3.607-13.061 0-3.606-3.606-3.606-9.454 0-13.061z",
    fill: "url(#SVGID_28_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 93.833c-89.008 0-161.167 72.158-161.167 161.167s72.159 161.167 161.167 161.167 161.167-72.159 161.167-161.167-72.159-161.167-161.167-161.167zm0 266.698c-58.285 0-105.531-47.246-105.531-105.531s47.246-105.531 105.531-105.531 105.531 47.246 105.531 105.531-47.246 105.531-105.531 105.531z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 392.323c75.841 0 137.323-61.482 137.323-137.323s-61.482-137.323-137.323-137.323-137.323 61.482-137.323 137.323 61.482 137.323 137.323 137.323zm0-242.854c58.285 0 105.531 47.246 105.531 105.531s-47.246 105.531-105.531 105.531-105.531-47.246-105.531-105.531 47.246-105.531 105.531-105.531z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.103 285.32c-13.028 43.505-53.358 75.211-101.103 75.211s-88.075-31.707-101.103-75.211h-57.203c14.187 74.512 79.664 130.847 158.306 130.847s144.119-56.335 158.306-130.847z",
    fill: "url(#SVGID_31_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_32_)",
    r: 55.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipWheel);
export default __webpack_public_path__ + "static/media/icon-ship-wheel.5d3108181bc883500794ee290c40c9f0.svg";
export { ForwardRef as ReactComponent };